import useValidation from "../useValidation";
import { validateExistingDeletionDate } from "./deletionDateValidation";
import validateDescription from "./descriptionValidation";
import validateFile from "./fileValidation";
import validateLicense from "./licenseValidation";
import validateSubtitles from "./subtitleValidation";
import validateTitle from "./titleValidation";
import validateLanguage from "./languageValidation";
import validateChapters from './chaptersValidation';

const validationFunctions = (record) => ({
  file: validateFile,
  title: validateTitle,
  description: validateDescription,
  license: validateLicense,
  deletionDate: validateExistingDeletionDate(record),
  selectedSubtitles: validateSubtitles,
  chapters: validateChapters,
  language: validateLanguage
});

const useRecordsValidation = (fields, records = []) => {
  const [isValids, messages, validate] = useValidation(
    records.map(record => validationFunctions(record)),
    fields
  );
  return [isValids, messages, validate];
};

export default useRecordsValidation;
